var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _g4, _path12, _path13, _path14, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem14B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs99"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.465,
    y1: 320.922,
    x2: 164.834,
    y2: 326.288,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -532.935,
    y1: 1529.963,
    x2: -333.563,
    y2: 1529.963,
    gradientTransform: "scale(-1 1) rotate(-1.542 -27075.778 4917.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.342,
    y1: 236.956,
    x2: 243.198,
    y2: 341.362,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.593,
    y1: -95.57,
    x2: 240.593,
    y2: 581.98,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4,
    y1: -85.846,
    x2: 241.4,
    y2: 577.354,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -83.068,
    y1: 504.503,
    x2: 205.603,
    y2: 506.633,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.991,
    y1: 505.375,
    x2: 303.192,
    y2: 506.212,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -362.003,
    y1: 689.823,
    x2: -162.645,
    y2: 689.823,
    gradientTransform: "scale(1 -1) rotate(89.496 632.55 421.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.873,
    y1: 933.838,
    x2: 241.634,
    y2: 734.488,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.169,
    y1: 575.864,
    x2: 152.056,
    y2: 577.29,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.148,
    y1: 576.804,
    x2: 350.273,
    y2: 577.303,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop126"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -34.466,
    y1: 877.722,
    x2: 164.834,
    y2: 883.087,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -517.95,
    y1: 973.345,
    x2: -318.578,
    y2: 973.345,
    gradientTransform: "scale(-1 1) rotate(-1.542 -27075.778 4917.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -423.2,
    y1: 885.227,
    x2: 1215.2,
    y2: 885.227,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 397.428,
    x2: 483.156,
    y2: 397.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.398,
    y1: -290.523,
    x2: -1760.096,
    y2: -285.157,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 966.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop190"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -544.419,
    y1: 519.259,
    x2: -505.13,
    y2: 519.259,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.317,
    y1: 397.066,
    x2: 399.343,
    y2: 397.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.52,
    y1: -707.786,
    x2: -1685.52,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 966.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.71,
    y1: -698.061,
    x2: -1684.71,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 966.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 436.207,
    x2: 432.678,
    y2: 409.432,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 364.972,
    x2: 432.675,
    y2: 382.821,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.318,
    y1: 397.066,
    x2: 474.344,
    y2: 397.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 507.428,
    x2: 483.156,
    y2: 507.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.394,
    y1: -290.527,
    x2: -1760.094,
    y2: -285.162,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 856.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -434.46,
    y1: 522.273,
    x2: -395.171,
    y2: 522.273,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.317,
    y1: 507.066,
    x2: 399.343,
    y2: 507.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop317"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.52,
    y1: -707.786,
    x2: -1685.52,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 856.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop324"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.708,
    y1: -698.061,
    x2: -1684.708,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 856.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 546.206,
    x2: 432.677,
    y2: 519.431,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 474.972,
    x2: 432.675,
    y2: 492.822,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop355"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.318,
    y1: 507.066,
    x2: 474.344,
    y2: 507.229,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 627.428,
    x2: 483.156,
    y2: 627.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.392,
    y1: -290.525,
    x2: -1760.095,
    y2: -285.159,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 736.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop392"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: -314.506,
    y1: 525.56,
    x2: -275.216,
    y2: 525.56,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.318,
    y1: 627.067,
    x2: 399.343,
    y2: 627.231,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop418"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.517,
    y1: -707.786,
    x2: -1685.517,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 736.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.704,
    y1: -698.06,
    x2: -1684.704,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 736.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 666.208,
    x2: 432.678,
    y2: 639.432,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop445"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 594.973,
    x2: 432.675,
    y2: 612.822,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.317,
    y1: 627.067,
    x2: 474.343,
    y2: 627.231,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop467"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient683",
    gradientUnits: "userSpaceOnUse",
    x1: -34.465,
    y1: 320.922,
    x2: 164.834,
    y2: 326.288,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop681"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M241.1 759.8c15.2-5.565 32.85-9.917 52.95-13.05 19.6-3.033 40-4.7 61.2-5 45.667-.6 84.133 4.667 115.4 15.8 35.133 12.5 52.833 30.117 53.1 52.852-1.967 21.1-19.917 37.85-53.85 50.25-30.8 11.266-67.9 16.898-111.3 16.898-43.6-.033-80.85-5.767-111.75-17.2-34.333-12.731-52.783-30.083-55.35-52.05-.633-10.065 3.617-19.35 12.75-27.85 8.467-7.9 20.75-14.783 36.85-20.65z",
    id: "path9",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M241.1 759.8c15.2-5.565 32.85-9.917 52.95-13.05 19.6-3.033 40-4.7 61.2-5 45.667-.6 84.133 4.667 115.4 15.8 35.133 12.5 52.833 30.117 53.1 52.852-1.967 21.1-19.917 37.85-53.85 50.25-30.8 11.266-67.9 16.898-111.3 16.898-43.6-.033-80.85-5.767-111.75-17.2-34.333-12.731-52.783-30.083-55.35-52.05-.633-10.065 3.617-19.35 12.75-27.85 8.467-7.9 20.75-14.783 36.85-20.65z",
    id: "path11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient694",
    gradientUnits: "userSpaceOnUse",
    x1: -532.935,
    y1: 1529.963,
    x2: -333.563,
    y2: 1529.963,
    gradientTransform: "scale(-1 1) rotate(-1.542 -27075.778 4917.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop692"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M191.45 810.4c.267-22.733 17.966-40.352 53.1-52.852 31.267-11.133 69.733-16.398 115.4-15.8 21.2.3 41.6 1.967 61.2 5 20.1 3.133 37.75 7.483 52.949 13.05 16.101 5.867 28.384 12.75 36.851 20.65 9.133 8.5 13.383 17.783 12.75 27.85-2.566 21.967-21.018 39.317-55.351 52.05-30.899 11.435-68.149 17.167-111.75 17.2-43.4 0-80.5-5.633-111.3-16.898-33.932-12.4-51.882-29.15-53.849-50.25z",
    id: "path22",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M191.45 810.4c1.966 21.1 19.917 37.85 53.85 50.25 30.8 11.267 67.9 16.898 111.3 16.898 43.6-.033 80.85-5.767 111.75-17.2 34.333-12.731 52.784-30.083 55.351-52.05.633-10.065-3.617-19.35-12.75-27.85-8.468-7.9-20.75-14.783-36.851-20.65-15.199-5.565-32.85-9.917-52.949-13.05-19.601-3.033-40-4.7-61.201-5-45.667-.6-84.134 4.667-115.4 15.8-35.133 12.502-52.833 30.119-53.1 52.852z",
    id: "path24"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient706",
    gradientUnits: "userSpaceOnUse",
    x1: 244.342,
    y1: 236.956,
    x2: 243.198,
    y2: 341.362,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop704"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "m528.45 771.85-5.425 40.575c-4.292 20.023-22.518 35.999-54.676 47.925-30.899 11.435-68.149 17.167-111.75 17.2-43.4 0-80.5-5.633-111.3-16.898-29.73-10.864-47.188-25.064-52.375-42.602L189.5 780.9a126.175 126.175 0 0 1 15.65-1c7.539-.003 15.139.664 22.8 2 7.667 1.333 19.617 4.398 35.85 9.198 16.8 4.935 30.534 8.4 41.2 10.4 17.434 3.3 35.6 4.883 54.5 4.75 18.633-.133 37.383-2.217 56.25-6.25 13.033-2.767 28.217-7.017 45.55-12.75 20.667-6.867 32.967-10.833 36.9-11.9 1.655-.444 3.271-.854 4.85-1.225 9.996-2.32 18.463-3.079 25.4-2.273z",
    id: "path36",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient713",
    gradientUnits: "userSpaceOnUse",
    x1: 240.593,
    y1: -95.57,
    x2: 240.593,
    y2: 581.98,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop711"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M523.75 797.4c.027.962.011 1.929-.05 2.898-2.566 21.967-21.018 39.317-55.351 52.05-30.899 11.435-68.149 17.167-111.75 17.2-43.4 0-80.5-5.633-111.3-16.898-28.608-10.455-45.858-24.006-51.75-40.65a132.172 132.172 0 0 1-3.1-4.55c-.499-.542-.841-1.117-1.025-1.727 21.511 14.865 40.136 25.175 55.875 30.927 30.8 11.267 67.9 16.898 111.3 16.898 43.6-.033 80.85-5.767 111.75-17.2 22.187-8.226 40.653-21.209 55.401-38.948z",
    id: "path43",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient720",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4,
    y1: -85.846,
    x2: 241.4,
    y2: 577.354,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop718"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M251.1 848.8c-31.5-11.065-51.15-25.217-58.95-42.45 25.367 17.133 54.55 29.35 87.55 36.65 29.966 6.6 61.183 8.8 93.65 6.6 30.3-2.065 58.633-7.683 85-16.85 25.867-9 47.301-20.617 64.301-34.85-11.867 23.565-34.284 41.231-67.25 53-29.434 10.5-63.783 15.383-103.05 14.648-37.734-.665-71.484-6.248-101.251-16.748z",
    id: "path50",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M257.725 442.475c.24-.13.49-.154.75-.074 1.925.558 3.867 1.1 5.825 1.625.272.074.48.232.625.475a.938.938 0 0 1 .1.75c-.075.272-.233.48-.475.625a.946.946 0 0 1-.75.1c-1.975-.542-3.933-1.1-5.875-1.675a.96.96 0 0 1-.6-.475.928.928 0 0 1-.075-.75.965.965 0 0 1 .475-.601zm-12-2.275-.7-.2h-.075a133.041 133.041 0 0 1-4.875-1.875.951.951 0 0 1-.55-.525.982.982 0 0 1 0-.774c.1-.257.275-.44.525-.55a.993.993 0 0 1 .775 0 134.63 134.63 0 0 0 4.825 1.824h-.075l.7.2a.967.967 0 0 1 .6.476c.13.238.155.488.075.75a.969.969 0 0 1-.475.6.94.94 0 0 1-.75.074zm7.75-36.675a.969.969 0 0 1 .475.6.936.936 0 0 1-.075.75.969.969 0 0 1-.6.475.936.936 0 0 1-.75-.074 53.968 53.968 0 0 1-5.05-3.15.97.97 0 0 1-.4-.65.965.965 0 0 1 .15-.75.96.96 0 0 1 .65-.399.969.969 0 0 1 .75.149 51.93 51.93 0 0 0 4.85 3.049zm16.875 7.175c.268.086.468.253.6.5a.93.93 0 0 1 .05.75 1.004 1.004 0 0 1-.5.6.926.926 0 0 1-.75.05 135.07 135.07 0 0 1-5.6-1.975.956.956 0 0 1-.55-.525.925.925 0 0 1-.025-.75.956.956 0 0 1 .525-.55.92.92 0 0 1 .75-.024c1.751.657 3.584 1.299 5.5 1.924zm47.85 10.8a.983.983 0 0 1 .375-.675.957.957 0 0 1 .725-.226c1.958.2 3.934.384 5.925.551.282.022.515.14.7.35.176.21.251.452.225.725a1.003 1.003 0 0 1-.35.7.952.952 0 0 1-.725.226c-2.009-.167-4-.351-5.975-.551a.973.973 0 0 1-.675-.375.948.948 0 0 1-.225-.725zm-30.125-5.925a.975.975 0 0 1 .625.45.948.948 0 0 1 .125.75.976.976 0 0 1-.45.625.948.948 0 0 1-.75.125c-1.942-.434-3.85-.899-5.725-1.4a1.024 1.024 0 0 1-.625-.475.942.942 0 0 1-.1-.75c.075-.271.233-.48.475-.625a.945.945 0 0 1 .75-.101c1.858.501 3.75.968 5.675 1.401zm19.075 3.775a.994.994 0 0 1 .2.75.96.96 0 0 1-.4.65.994.994 0 0 1-.75.2 275.58 275.58 0 0 1-5.925-.976.965.965 0 0 1-.65-.399.963.963 0 0 1-.15-.75.96.96 0 0 1 .4-.65.965.965 0 0 1 .75-.149c1.925.324 3.883.633 5.875.925a.954.954 0 0 1 .65.399zm14.875-19.525a.959.959 0 0 1 .75-.15c1.925.358 3.9.684 5.925.976.27.043.486.176.65.399a.994.994 0 0 1 .2.75.957.957 0 0 1-.4.65.996.996 0 0 1-.75.2c-2.042-.309-4.034-.65-5.975-1.025a.964.964 0 0 1-.65-.4.963.963 0 0 1-.15-.75.96.96 0 0 1 .4-.65zm-18.15-4.425a.92.92 0 0 1 .5-.551.985.985 0 0 1 .775-.024 96.369 96.369 0 0 0 5.45 1.825.92.92 0 0 1 .575.475.99.99 0 0 1 .075.775.919.919 0 0 1-.475.574.993.993 0 0 1-.775.075 94.843 94.843 0 0 1-5.55-1.875.916.916 0 0 1-.55-.5.982.982 0 0 1-.025-.774zm-15.15-8.975a.965.965 0 0 1-.15-.75.96.96 0 0 1 1.15-.799.965.965 0 0 1 .65.4c.977 1.387 2.268 2.694 3.875 3.925.224.173.357.397.4.675a.93.93 0 0 1-.2.725 1.01 1.01 0 0 1-.675.4.931.931 0 0 1-.725-.2c-1.793-1.371-3.235-2.829-4.325-4.376zm5.975-16.9a1.02 1.02 0 0 1-.4.675c-1.703 1.289-3.044 2.655-4.025 4.1a.946.946 0 0 1-.625.425.96.96 0 0 1-.75-.149.949.949 0 0 1-.425-.625.959.959 0 0 1 .15-.75c1.086-1.623 2.578-3.156 4.475-4.601a.932.932 0 0 1 .725-.199c.277.042.502.175.675.399a.931.931 0 0 1 .2.725zm3.025-19.9a.964.964 0 0 1-.65.4 264 264 0 0 0-5.875 1.149.964.964 0 0 1-.75-.149.942.942 0 0 1-.425-.625.96.96 0 0 1 .15-.75.949.949 0 0 1 .625-.426c1.942-.399 3.917-.782 5.925-1.149a.962.962 0 0 1 .75.149c.222.16.355.376.4.65a.964.964 0 0 1-.15.751zm13.25 11.075.3-.101a.99.99 0 0 1 .775.051.956.956 0 0 1 .5.574.986.986 0 0 1-.05.775.961.961 0 0 1-.575.5l-.3.1-.05.025a85.605 85.605 0 0 0-5.75 1.775.932.932 0 0 1-.75-.051.998.998 0 0 1-.525-.574.93.93 0 0 1 .05-.75 1 1 0 0 1 .575-.525 86.66 86.66 0 0 1 5.85-1.825zm-52.125-2a.925.925 0 0 1 .75-.025c.255.1.438.273.55.525a.925.925 0 0 1 .025.75 1.004 1.004 0 0 1-.525.575 91.175 91.175 0 0 0-5.375 2.6.999.999 0 0 1-.775.075.92.92 0 0 1-.575-.476.996.996 0 0 1-.075-.774.927.927 0 0 1 .475-.575 94.403 94.403 0 0 1 5.525-2.675zm17-5.975 2-.5a.954.954 0 0 1 .75.125.976.976 0 0 1 .475.601.952.952 0 0 1-.125.75.972.972 0 0 1-.6.475l-2 .5.025-.024c-1.591.467-3.133.934-4.625 1.399a.986.986 0 0 1-.775-.075.916.916 0 0 1-.475-.574.99.99 0 0 1 .075-.775.922.922 0 0 1 .575-.475c1.508-.468 3.066-.934 4.675-1.4zm4.775-27.45a.966.966 0 0 1 .75.149c.222.16.355.377.4.65a.959.959 0 0 1-.15.75.96.96 0 0 1-.65.399c-1.983.367-3.95.768-5.9 1.2a1.008 1.008 0 0 1-.775-.125.94.94 0 0 1-.425-.625 1.007 1.007 0 0 1 .125-.774.948.948 0 0 1 .625-.426c1.983-.431 3.983-.831 6-1.198zm-25.25 6.4a.973.973 0 0 1 .6-.475 296.07 296.07 0 0 1 5.875-1.675.946.946 0 0 1 .75.1c.242.145.4.353.475.625a.942.942 0 0 1-.1.75c-.145.242-.353.4-.625.475-1.958.525-3.9 1.066-5.825 1.625a.937.937 0 0 1-.75-.074.965.965 0 0 1-.475-.601.936.936 0 0 1 .075-.75zm54.4 14.425c1.975-.232 3.983-.449 6.025-.649a.95.95 0 0 1 .725.225.985.985 0 0 1 .375.675.95.95 0 0 1-.225.726.985.985 0 0 1-.675.375c-2.025.2-4.017.417-5.975.649a1.013 1.013 0 0 1-.75-.225.932.932 0 0 1-.375-.65 1.009 1.009 0 0 1 .225-.75.927.927 0 0 1 .65-.376zm-10.25-23.85a.93.93 0 0 1 .725.2c.225.172.358.396.4.675a.93.93 0 0 1-.2.725 1.01 1.01 0 0 1-.675.4c-1.992.267-3.967.55-5.925.85a.99.99 0 0 1-.75-.199.96.96 0 0 1-.4-.65.985.985 0 0 1 .2-.75.963.963 0 0 1 .65-.4c1.975-.301 3.967-.584 5.975-.851zm19.825-1.7a.973.973 0 0 1 .1 1.401.96.96 0 0 1-.675.35c-2.025.167-4.033.351-6.025.55a.95.95 0 0 1-.725-.225.985.985 0 0 1-.375-.675.952.952 0 0 1 .225-.726.985.985 0 0 1 .675-.375 355.02 355.02 0 0 1 6.075-.55.97.97 0 0 1 .725.25zm-83.25 65.625a.983.983 0 0 1 .625-.45.95.95 0 0 1 .75.125.977.977 0 0 1 .45.625c.409 1.796 1.118 3.529 2.125 5.2.146.244.188.502.125.775a.927.927 0 0 1-.45.6 1.012 1.012 0 0 1-.775.125.927.927 0 0 1-.6-.45c-1.126-1.862-1.917-3.796-2.375-5.8a.954.954 0 0 1 .125-.75zM238.375 375a1.014 1.014 0 0 1 .125-.775c1.039-1.728 2.355-3.386 3.95-4.975a.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.955.955 0 0 1 .3.7.955.955 0 0 1-.3.7c-1.472 1.478-2.689 3.02-3.65 4.625a.936.936 0 0 1-.6.449.952.952 0 0 1-.75-.125.963.963 0 0 1-.475-.599zM204.1 357.95a61.856 61.856 0 0 1 4.625-4.175.956.956 0 0 1 .725-.226c.274.032.5.157.675.375a.953.953 0 0 1 .225.726.993.993 0 0 1-.375.675 59.731 59.731 0 0 0-4.475 4.024.956.956 0 0 1-.7.301.954.954 0 0 1-.7-.301.95.95 0 0 1-.3-.699.951.951 0 0 1 .3-.7zm-13.6 28.9a.98.98 0 0 1 .325-.699.958.958 0 0 1 .725-.25.987.987 0 0 1 .7.324.973.973 0 0 1 .25.726 35.25 35.25 0 0 0-.05 1.75c.126 1.166.301 2.315.525 3.45.054.27.003.52-.15.75a.946.946 0 0 1-.625.425.96.96 0 0 1-.75-.15.937.937 0 0 1-.425-.625 42.515 42.515 0 0 1-.575-3.649 37.333 37.333 0 0 1 .05-2.052zm6.025-18.925a.998.998 0 0 1 .775.101c.242.136.4.336.475.6.071.271.038.529-.1.775a43.647 43.647 0 0 0-2.55 5.274.957.957 0 0 1-.525.55.984.984 0 0 1-.775 0 .955.955 0 0 1-.55-.524.984.984 0 0 1 0-.775 45.457 45.457 0 0 1 2.65-5.524.964.964 0 0 1 .6-.477zm40.5-30.2a123.797 123.797 0 0 1 5.6-2.125.932.932 0 0 1 .75.051c.253.122.429.313.525.574a.927.927 0 0 1-.05.75 1 1 0 0 1-.575.525c-1.883.659-3.716 1.35-5.5 2.075a.932.932 0 0 1-.75 0 1.003 1.003 0 0 1-.55-.55.924.924 0 0 1 0-.75 1 1 0 0 1 .55-.55zm-12 5.5a.999.999 0 0 1 .775-.074c.258.076.45.234.575.475.13.249.156.507.075.775a.925.925 0 0 1-.475.574 129.898 129.898 0 0 0-5.275 2.926.955.955 0 0 1-.75.125.964.964 0 0 1-.6-.476.952.952 0 0 1-.125-.75.973.973 0 0 1 .475-.6c1.708-1.009 3.483-2 5.325-2.975zM524.35 387.3c.17.227.236.477.2.75a43.381 43.381 0 0 1-1.35 5.976.966.966 0 0 1-.477.6.936.936 0 0 1-.75.075.968.968 0 0 1-.6-.476.936.936 0 0 1-.075-.75 41.537 41.537 0 0 0 1.25-5.725.962.962 0 0 1 .4-.65.993.993 0 0 1 .75-.199c.273.042.49.175.652.399zm-4.425-18.65a.968.968 0 0 1 .602.475 35.126 35.126 0 0 1 2.523 5.6.93.93 0 0 1-.05.75.994.994 0 0 1-.575.525.927.927 0 0 1-.75-.05.987.987 0 0 1-.523-.575 33.415 33.415 0 0 0-2.375-5.3.936.936 0 0 1-.075-.75.96.96 0 0 1 .475-.601.934.934 0 0 1 .748-.074zm-11.95-13.675a88.303 88.303 0 0 1 3.65 3.125h-.025c.268.233.534.468.801.7a.968.968 0 0 1 .1 1.401.955.955 0 0 1-.675.35.962.962 0 0 1-.726-.25c-.267-.232-.532-.466-.8-.7h-.024a85.105 85.105 0 0 0-3.551-3.074.993.993 0 0 1-.375-.676.953.953 0 0 1 .226-.725.979.979 0 0 1 .675-.375.944.944 0 0 1 .724.224zm-17.525-9.025a.93.93 0 0 1 .075-.75.958.958 0 0 1 .574-.5.93.93 0 0 1 .75.05 126.8 126.8 0 0 1 5.25 2.875c.242.145.4.354.476.625a.937.937 0 0 1-.101.75c-.145.242-.354.4-.625.475a.946.946 0 0 1-.75-.1c-1.649-.958-3.366-1.9-5.149-2.825a1.013 1.013 0 0 1-.5-.6zm-5.7 36.65a.996.996 0 0 1 .2.75 21.525 21.525 0 0 1-1.851 6.025 1.002 1.002 0 0 1-.574.525.928.928 0 0 1-.75-.051.998.998 0 0 1-.525-.574.932.932 0 0 1 .05-.75 19.475 19.475 0 0 0 1.65-5.476.959.959 0 0 1 .399-.649.994.994 0 0 1 .75-.2.96.96 0 0 1 .651.4zm-17.95-21.025a.984.984 0 0 1-.05.774.959.959 0 0 1-.575.5.984.984 0 0 1-.774-.05 93.245 93.245 0 0 0-5.375-2.425 1.001 1.001 0 0 1-.551-.55.932.932 0 0 1 0-.75.995.995 0 0 1 .551-.55c.25-.106.5-.106.75 0a95.738 95.738 0 0 1 5.524 2.475.97.97 0 0 1 .5.576zm9.025 7.8a.985.985 0 0 1-.375-.675.944.944 0 0 1 .225-.726.985.985 0 0 1 .675-.375.96.96 0 0 1 .726.226c1.737 1.422 3.178 2.896 4.325 4.425a.99.99 0 0 1 .199.75.964.964 0 0 1-.399.65.993.993 0 0 1-.75.199.965.965 0 0 1-.65-.399c-1.054-1.406-2.38-2.764-3.976-4.075zM435.7 381.25a.96.96 0 0 1 .5-.575.957.957 0 0 1 1.325.425c.13.241.155.491.074.75-.602 1.924-1.668 3.758-3.199 5.5a.967.967 0 0 1-1.401.101.967.967 0 0 1-.1-1.401c1.336-1.524 2.269-3.123 2.801-4.8zm-19.45 14.625c.122-.253.313-.428.575-.525a68.481 68.481 0 0 0 5.475-2.149.925.925 0 0 1 .75-.025.96.96 0 0 1 .55.525.925.925 0 0 1 .025.75.96.96 0 0 1-.525.55 69.46 69.46 0 0 1-5.625 2.25.931.931 0 0 1-.75-.05.992.992 0 0 1-.524-.575.925.925 0 0 1 .049-.751zm-1.3-32.35c-.133-.033-.268-.066-.4-.101h-.024a131.474 131.474 0 0 0-5.2-1.35.977.977 0 0 1-.625-.45.951.951 0 0 1-.125-.75.969.969 0 0 1 .45-.625.95.95 0 0 1 .75-.125c1.851.433 3.617.883 5.3 1.35h-.025c.133.033.268.066.4.101a.965.965 0 0 1 .6.475.952.952 0 0 1 .125.75.966.966 0 0 1-.475.601.96.96 0 0 1-.751.124zm11.7 4.45a.961.961 0 0 1-.5-.574.929.929 0 0 1 .074-.75.96.96 0 0 1 1.325-.426c1.645.852 3.103 1.734 4.375 2.65l.025.025c.226.156.451.314.675.475a.967.967 0 0 1 .4.65.975.975 0 0 1-.176.75.908.908 0 0 1-.625.399.969.969 0 0 1-.75-.149l-.699-.5-.025-.025c-1.188-.874-2.555-1.715-4.099-2.525zm4.025-17.7a.959.959 0 0 1 .15.75.959.959 0 0 1-1.15.799 264.66 264.66 0 0 0-5.899-1.05.911.911 0 0 1-.625-.4.973.973 0 0 1-.176-.75.911.911 0 0 1 .4-.625.972.972 0 0 1 .75-.175c2 .333 3.967.683 5.9 1.05.273.046.49.179.65.401zm11.175 2.55a.938.938 0 0 1 .75-.101c1.608.441 3.185.884 4.726 1.325l-.025-.024 1.2.3a.963.963 0 0 1 .6.475.952.952 0 0 1 .125.75.966.966 0 0 1-.475.601.954.954 0 0 1-.75.125l-1.2-.301-.024-.024a415.286 415.286 0 0 0-4.676-1.275 1.02 1.02 0 0 1-.625-.475.938.938 0 0 1-.1-.75c.074-.273.232-.481.474-.626zm-8.975-26.65c.273.045.49.178.65.4a.962.962 0 0 1 .149.75.96.96 0 0 1-.399.649.963.963 0 0 1-.75.15c-1.935-.367-3.9-.716-5.9-1.05a.913.913 0 0 1-.625-.4.972.972 0 0 1-.175-.75.912.912 0 0 1 .399-.625.978.978 0 0 1 .75-.175c2.001.334 3.968.684 5.901 1.051zm-18.45-3.075c.278.042.502.176.675.4a.93.93 0 0 1 .2.725 1.022 1.022 0 0 1-.399.676.932.932 0 0 1-.726.199c-2-.267-4-.517-6-.75a.925.925 0 0 1-.649-.375 1.011 1.011 0 0 1-.226-.75.93.93 0 0 1 .375-.649c.222-.177.472-.252.75-.226 2 .233 4 .483 6 .75zm59.25 14.2a.988.988 0 0 1 .775-.05c1.908.708 3.767 1.433 5.575 2.175.257.109.439.292.55.55.105.25.105.5 0 .75-.108.258-.292.44-.55.551a.932.932 0 0 1-.75 0 171.247 171.247 0 0 0-5.525-2.125.956.956 0 0 1-.55-.525.98.98 0 0 1-.05-.775.958.958 0 0 1 .525-.551zm-28.05-8.475c1.967.466 3.917.933 5.85 1.399a.98.98 0 0 1 .625.45.951.951 0 0 1 .125.75.972.972 0 0 1-.449.625.951.951 0 0 1-.75.125c-1.935-.466-3.884-.933-5.851-1.399a.978.978 0 0 1-.625-.45.951.951 0 0 1-.125-.75.97.97 0 0 1 .45-.625.951.951 0 0 1 .75-.125zm17.725 5.05a.939.939 0 0 1 .75-.075c1.9.601 3.768 1.2 5.601 1.8.268.086.468.253.6.5.123.242.14.492.05.75a1.003 1.003 0 0 1-.5.601.93.93 0 0 1-.75.05c-1.833-.6-3.699-1.2-5.6-1.8a.958.958 0 0 1-.575-.5.96.96 0 0 1 .424-1.326zM387.6 356.45c.274.032.5.157.675.375a.948.948 0 0 1 .225.725.98.98 0 0 1-.375.675.953.953 0 0 1-.725.226c-1.958-.2-3.934-.383-5.925-.55a1.01 1.01 0 0 1-.7-.351.947.947 0 0 1-.225-.725c.023-.281.14-.516.35-.7a.954.954 0 0 1 .725-.225c2.008.167 4 .35 5.975.55zm9.4 1.2a.965.965 0 0 1 .65.399c.17.227.235.477.199.75a.965.965 0 0 1-.399.65 1 1 0 0 1-.75.2c-1.926-.301-3.9-.566-5.925-.801a.925.925 0 0 1-.65-.375 1.006 1.006 0 0 1-.225-.75.93.93 0 0 1 .375-.649c.222-.177.472-.252.75-.226 2.042.235 4.034.502 5.975.802zm7.825-9.825a.958.958 0 0 1-.226-.726.987.987 0 0 1 .375-.675.951.951 0 0 1 .726-.225c.667.065 1.333.133 2 .2 1.216.133 2.417.282 3.6.449a.96.96 0 0 1 .65.4.996.996 0 0 1 .2.75.965.965 0 0 1-.4.65.99.99 0 0 1-.75.199 112.39 112.39 0 0 0-3.5-.449l-2-.2a.975.975 0 0 1-.675-.373zm-80.55 9.95c1.95-.343 3.95-.65 6-.926a.932.932 0 0 1 .725.2c.225.173.358.398.4.675a.93.93 0 0 1-.2.726 1.016 1.016 0 0 1-.675.399c-2.016.259-3.983.551-5.9.875a.965.965 0 0 1-.75-.149.96.96 0 0 1-.4-.65.963.963 0 0 1 .15-.75.963.963 0 0 1 .65-.4zm25.95-2.2a.978.978 0 0 1 .325.7.926.926 0 0 1-.275.699.98.98 0 0 1-.7.325c-2.05.067-4.05.167-6 .3a.957.957 0 0 1-.725-.25.97.97 0 0 1-.1-1.4.961.961 0 0 1 .675-.351 173.08 173.08 0 0 1 6.1-.3.948.948 0 0 1 .7.277zm11.475.525a.95.95 0 0 1 .3-.699.956.956 0 0 1 .7-.301h.625c1.766.033 3.516.066 5.25.101a.956.956 0 0 1 .7.3c.19.204.282.445.275.725a.954.954 0 0 1-.3.7.99.99 0 0 1-.725.275l-5.225-.101h-.6a.955.955 0 0 1-.7-.3.951.951 0 0 1-.3-.7zm-13.575-10.5a.99.99 0 0 1-.725-.274.957.957 0 0 1-.3-.7.989.989 0 0 1 .275-.725.958.958 0 0 1 .7-.301c2-.032 4.017-.066 6.05-.1a.991.991 0 0 1 .725.275.954.954 0 0 1 .3.699.993.993 0 0 1-.275.726.957.957 0 0 1-.7.3l-6.05.1zm-19.875-.9a.96.96 0 0 1 .675-.351c2.008-.134 4.033-.25 6.075-.35a.982.982 0 0 1 1.05.95.968.968 0 0 1-.25.725.976.976 0 0 1-.7.325c-2.025.1-4.033.217-6.025.35a.962.962 0 0 1-.725-.25.965.965 0 0 1-.1-1.399zm3.575-23.2a.932.932 0 0 1-.7-.275.977.977 0 0 1-.325-.699.932.932 0 0 1 .275-.7.98.98 0 0 1 .7-.325l6.05-.2a.933.933 0 0 1 .7.275.978.978 0 0 1 .325.7.93.93 0 0 1-.275.699.983.983 0 0 1-.7.325l-6.05.2zm18.325-2.1a.956.956 0 0 1 .7-.301c2.008 0 4.05.018 6.125.051a.986.986 0 0 1 .975 1.025.956.956 0 0 1-.3.7.987.987 0 0 1-.725.275 379.17 379.17 0 0 0-6.075-.051.955.955 0 0 1-.7-.3.954.954 0 0 1-.3-.7.955.955 0 0 1 .3-.699zm36.375 25.05c2 .133 4 .283 6 .45.282.022.515.14.7.35.176.21.251.452.225.725a1.01 1.01 0 0 1-.35.7.955.955 0 0 1-.725.226c-2-.167-4-.316-6-.45a.956.956 0 0 1-.675-.351.964.964 0 0 1-.25-.725.95.95 0 0 1 .35-.675.97.97 0 0 1 .725-.25zm-19.1 1.15a.986.986 0 0 1-.975-1.025.956.956 0 0 1 .3-.7.987.987 0 0 1 .725-.275c2 .033 4 .083 6 .15a.985.985 0 0 1 .7.325.93.93 0 0 1 .275.7.981.981 0 0 1-.325.699.937.937 0 0 1-.7.275c-2-.066-4-.116-6-.149zm2.15-25.925a.935.935 0 0 1 .7-.274c2.008.065 4.017.149 6.025.25a.987.987 0 0 1 .7.324.966.966 0 0 1 .25.726.982.982 0 0 1-1.05.95 341.314 341.314 0 0 0-5.975-.25.983.983 0 0 1-.7-.325.938.938 0 0 1-.275-.7.98.98 0 0 1 .325-.701zm18.675 1.75a.953.953 0 0 1 .35-.675.964.964 0 0 1 .725-.25c2.033.167 4.05.333 6.05.5.282.023.515.14.7.35.176.21.251.452.225.726a1 1 0 0 1-.35.7.95.95 0 0 1-.725.225c-2-.167-4.017-.333-6.05-.5a.949.949 0 0 1-.675-.35.97.97 0 0 1-.25-.726zm-105.7 126.9a.94.94 0 0 1 .625.425.96.96 0 0 1 .15.75.944.944 0 0 1-.425.625.96.96 0 0 1-.75.15c-1.975-.4-3.934-.816-5.875-1.25a.982.982 0 0 1-.625-.45.95.95 0 0 1-.125-.75.968.968 0 0 1 .45-.625.948.948 0 0 1 .75-.125c1.925.433 3.867.85 5.825 1.25zm11.85 2.425a.994.994 0 0 1 .75-.2c1.925.3 3.867.583 5.825.851.277.042.502.175.675.399a.931.931 0 0 1 .2.726 1.017 1.017 0 0 1-.4.675.942.942 0 0 1-.725.2 321.444 321.444 0 0 1-5.875-.851.96.96 0 0 1-.65-.399.972.972 0 0 1-.175-.75.932.932 0 0 1 .375-.651zm25.85 4.475a.955.955 0 0 1-.725.226c-2.008-.167-4-.351-5.975-.55a.983.983 0 0 1-.675-.375.953.953 0 0 1-.225-.726.985.985 0 0 1 .375-.675.952.952 0 0 1 .725-.225c1.958.199 3.933.383 5.925.55.282.022.515.14.7.35.176.21.251.452.225.726a1.01 1.01 0 0 1-.35.699zm-113-36.3a.966.966 0 0 1 .25-.725.966.966 0 0 1 1.4-.101 64.632 64.632 0 0 0 4.55 3.65c.224.163.357.38.4.65a.994.994 0 0 1-.2.75.96.96 0 0 1-.65.399.994.994 0 0 1-.75-.2 65.97 65.97 0 0 1-4.65-3.75.95.95 0 0 1-.35-.673zm-11.825-14a.937.937 0 0 1-.075-.75.967.967 0 0 1 .475-.6.93.93 0 0 1 .75-.075.975.975 0 0 1 .6.475 41.911 41.911 0 0 0 3.125 4.926.994.994 0 0 1 .2.75.959.959 0 0 1-.4.649.99.99 0 0 1-.75.2.963.963 0 0 1-.65-.4 43.882 43.882 0 0 1-3.275-5.175zm27.35 23.925a.93.93 0 0 1 .6-.449.996.996 0 0 1 .775.074c1.65.926 3.367 1.833 5.15 2.726a.958.958 0 0 1 .5.575.984.984 0 0 1-.05.774.955.955 0 0 1-.575.5.99.99 0 0 1-.775-.05 126.826 126.826 0 0 1-5.25-2.775.934.934 0 0 1-.45-.6.995.995 0 0 1 .075-.775zm264.475.525a.958.958 0 0 1 1.325.425c.13.242.155.492.075.75a1.006 1.006 0 0 1-.5.601c-1.741.899-3.55 1.783-5.426 2.649a.982.982 0 0 1-.774.05.952.952 0 0 1-.55-.524.988.988 0 0 1-.051-.775.965.965 0 0 1 .525-.55c1.859-.859 3.65-1.734 5.376-2.626zm16.125-10.55a.957.957 0 0 1 .725-.226.99.99 0 0 1 .676.375.951.951 0 0 1 .225.726.99.99 0 0 1-.375.675 78.207 78.207 0 0 1-4.8 3.65c-.04.026-.082.052-.125.074a9.373 9.373 0 0 0-.2.101.99.99 0 0 1-.775.05.957.957 0 0 1-.574-.5.99.99 0 0 1-.051-.775.963.963 0 0 1 .5-.574.94.94 0 0 0 .125-.075 73.339 73.339 0 0 0 4.649-3.501zm14.5-13.5c.063.274.021.534-.125.774a54.398 54.398 0 0 1-3.625 4.976.993.993 0 0 1-.675.375.96.96 0 0 1-.727-.226.98.98 0 0 1-.375-.675.963.963 0 0 1 .227-.725 53.219 53.219 0 0 0 3.475-4.825.946.946 0 0 1 .625-.425c.276-.063.535-.021.775.125.229.15.37.358.425.626zM414.55 420.65a1 1 0 0 1-.75-.2.96.96 0 0 1-.399-.65.995.995 0 0 1 .199-.75.957.957 0 0 1 .65-.399c1.992-.292 3.95-.601 5.875-.926a.967.967 0 0 1 .75.15.963.963 0 0 1 .4.65.963.963 0 0 1-.15.75.961.961 0 0 1-.65.399c-1.941.343-3.916.668-5.925.976zm-9.225-21.075a.95.95 0 0 1-.125.75.986.986 0 0 1-.625.45c-1.95.434-3.95.833-6 1.199a.956.956 0 0 1-1.15-.799.967.967 0 0 1 .15-.75.965.965 0 0 1 .649-.399 144.49 144.49 0 0 0 5.9-1.2.948.948 0 0 1 .75.125.972.972 0 0 1 .451.624zm28 17.45a.95.95 0 0 1-.75-.125.975.975 0 0 1-.45-.625.95.95 0 0 1 .125-.75.976.976 0 0 1 .625-.45c1.958-.467 3.883-.95 5.775-1.45a.954.954 0 0 1 .75.125c.242.137.4.337.475.6a.952.952 0 0 1-.125.75.97.97 0 0 1-.6.476 254.3 254.3 0 0 1-5.825 1.449zm30.375 22.65a.999.999 0 0 1 .575-.524c1.125-.4 2.232-.801 3.324-1.2.135-.062.268-.111.4-.15.633-.225 1.25-.45 1.85-.675a.932.932 0 0 1 .75 0 .95.95 0 0 1 .525.55c.106.26.106.52 0 .775a.952.952 0 0 1-.55.524c-.608.242-1.233.483-1.875.726a1.104 1.104 0 0 0-.3.099.948.948 0 0 1-.101.05c-1.107.4-2.232.801-3.375 1.2a.927.927 0 0 1-.75-.05.999.999 0 0 1-.524-.575.936.936 0 0 1 .051-.75zm-17.525 4.975c1.936-.517 3.853-1.05 5.75-1.601a.936.936 0 0 1 .75.075.968.968 0 0 1 .476.6.932.932 0 0 1-.075.75.974.974 0 0 1-.601.476 300.995 300.995 0 0 1-5.875 1.675.92.92 0 0 1-.25.025h-.1a.952.952 0 0 1-.7-.301.957.957 0 0 1-.3-.699.954.954 0 0 1 .3-.7.957.957 0 0 1 .625-.3zm10.6-37.025c.25-.106.5-.106.75 0a1 1 0 0 1 .55.55c.105.25.105.5 0 .75a1 1 0 0 1-.55.55 135.845 135.845 0 0 1-5.7 2.176.932.932 0 0 1-.75-.051 1.001 1.001 0 0 1-.525-.574.935.935 0 0 1 .05-.75.994.994 0 0 1 .575-.525c1.95-.693 3.816-1.401 5.6-2.126zm18.175-8.475a.995.995 0 0 1-.375.675 46.529 46.529 0 0 1-5.101 3.625.951.951 0 0 1-.75.125.975.975 0 0 1-.625-.45.951.951 0 0 1-.125-.75.983.983 0 0 1 .45-.625 44.719 44.719 0 0 0 4.9-3.475.953.953 0 0 1 .725-.226.985.985 0 0 1 .675.375.951.951 0 0 1 .226.726zm-59.6 51.95a.957.957 0 0 1 .4.65.99.99 0 0 1-.2.75.961.961 0 0 1-.649.4c-1.976.3-3.968.583-5.976.85a.93.93 0 0 1-.725-.2 1.004 1.004 0 0 1-.4-.675.93.93 0 0 1 .2-.725c.172-.226.396-.358.675-.4 1.992-.267 3.967-.55 5.925-.85a.992.992 0 0 1 .75.2zm19.025-1.95a.944.944 0 0 1-.625.425c-1.942.399-3.9.783-5.875 1.149a.966.966 0 0 1-.75-.149.962.962 0 0 1-.4-.65.959.959 0 0 1 .15-.75.962.962 0 0 1 .65-.399c1.958-.367 3.899-.75 5.824-1.15a.96.96 0 0 1 .75.15.944.944 0 0 1 .426.625.96.96 0 0 1-.15.749zm-77.775 5.8h1.3a.951.951 0 0 1 .7.3.955.955 0 0 1 .3.7.955.955 0 0 1-.3.7.955.955 0 0 1-.7.3h-1.3c-1.775 0-3.533-.018-5.275-.05a.987.987 0 0 1-.975-1.026.956.956 0 0 1 .3-.7.993.993 0 0 1 .725-.274c1.725.033 3.467.05 5.225.05zm6.775-32.45a.933.933 0 0 1 .7.275c.205.19.313.424.325.699a.932.932 0 0 1-.275.7.98.98 0 0 1-.7.325c-1.275.034-2.566.05-3.875.05h-2.7a.951.951 0 0 1-.7-.3.955.955 0 0 1-.3-.7.955.955 0 0 1 .3-.7.955.955 0 0 1 .7-.3h2.7c1.291.001 2.567-.016 3.825-.049zM338 424.05a.982.982 0 0 1-.95-1.05.982.982 0 0 1 1.05-.95c1.958.101 3.933.185 5.925.25a.985.985 0 0 1 .7.325c.19.197.282.43.275.7a.983.983 0 0 1-.325.7.938.938 0 0 1-.7.274c-2.009-.066-4-.149-5.975-.249zm10.1-21.175a.969.969 0 0 1 .25.725.98.98 0 0 1-.325.7.961.961 0 0 1-.725.25c-2.008-.1-3.983-.232-5.925-.399a1.014 1.014 0 0 1-.7-.351.947.947 0 0 1-.225-.725 1 1 0 0 1 .35-.7.947.947 0 0 1 .725-.225c1.925.167 3.884.3 5.875.399a.987.987 0 0 1 .7.326zm35.05 20.7a.98.98 0 0 1-.7.325c-1.975.1-3.983.184-6.025.25a.933.933 0 0 1-.7-.275.98.98 0 0 1-.325-.7.933.933 0 0 1 .275-.7.974.974 0 0 1 .7-.324 324.18 324.18 0 0 0 5.975-.25.962.962 0 0 1 .725.25.98.98 0 0 1 .325.699.966.966 0 0 1-.25.725zM366.325 402.9a.992.992 0 0 1 .725.274.954.954 0 0 1 .3.7.986.986 0 0 1-.975 1.026c-1.508.032-3.033.05-4.575.05h-1.6a.96.96 0 0 1-.7-.3.953.953 0 0 1-.3-.7.951.951 0 0 1 .3-.7.951.951 0 0 1 .7-.3h1.6c1.525 0 3.033-.017 4.525-.05zm35 17.45c.276-.026.526.049.75.226a.932.932 0 0 1 .375.649c.026.278-.048.528-.226.75a.923.923 0 0 1-.649.375c-1.983.233-4 .435-6.05.601a.97.97 0 0 1-.725-.25.969.969 0 0 1-.1-1.401.958.958 0 0 1 .675-.35c2.017-.167 4-.367 5.95-.6zm-15.15-16.925a.98.98 0 0 1-.675.375c-1.975.2-3.983.367-6.025.5a.96.96 0 0 1-.725-.25.965.965 0 0 1-.1-1.4.957.957 0 0 1 .675-.351c2.024-.133 4.016-.3 5.975-.5a.953.953 0 0 1 .725.226.98.98 0 0 1 .375.675.948.948 0 0 1-.225.725zm10.35 51.35a.987.987 0 0 1-.675.375c-2.008.199-4.017.383-6.025.55a.953.953 0 0 1-.725-.226 1.005 1.005 0 0 1-.35-.699.95.95 0 0 1 .225-.726c.185-.21.418-.327.7-.35 1.992-.167 3.983-.352 5.975-.55a.95.95 0 0 1 .725.225.985.985 0 0 1 .375.675.948.948 0 0 1-.225.726zm-58.05-.175c.276.013.509.12.7.325a.93.93 0 0 1 .275.7.983.983 0 0 1-.325.7.936.936 0 0 1-.7.274c-2.008-.066-4-.149-5.975-.25a.985.985 0 0 1-.95-1.05.984.984 0 0 1 1.05-.95c1.958.101 3.933.184 5.925.251zm38.25-.1a.933.933 0 0 1 .7.275.977.977 0 0 1 .325.699.932.932 0 0 1-.275.7.981.981 0 0 1-.7.325l-6 .2a.937.937 0 0 1-.7-.275.976.976 0 0 1-.325-.7.93.93 0 0 1 .275-.699.98.98 0 0 1 .7-.325l6-.2z",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M253.35 441.65a.95.95 0 0 1 .3-.7.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699zm.3 28.3a.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699v-6a.955.955 0 0 1 .3-.7zm47.7-1.55a.95.95 0 0 1 .3-.7.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699zm-87.7-34.4a.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.955.955 0 0 1-.7.3.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7v-6a.955.955 0 0 1 .3-.7zm89.4 352.7a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm-48 31.25a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm2-29v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.951.951 0 0 1 .3.7zm-.3-29.7a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm49.7 26.05a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm0-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-89.4 82.3a.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.954.954 0 0 1 .3-.7zm1.4-29a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3zm0-29a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3zm-1.4-29a.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.954.954 0 0 1 .3-.7zm-.3-28.3a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7zm1.7-29.7a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3zm-1.7-28.3a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7zm88 62.7a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm-46 8.25a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7zm-.3-35.7a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm0-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm48 26.75a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm.3-29.7a.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.955.955 0 0 1 .3-.7zm1.4-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-48 31.25a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm.3-22.3a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7zm-2-35a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm1.7-29.7a.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699v-6a.95.95 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm48 26.75a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.4-29a.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699v-6a.955.955 0 0 1 .3-.7zm-86.6 82.3a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7v-6a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3zm-1.7-22.3v-6a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .955.955 0 0 1-.3-.7zm0-35a.95.95 0 0 1 .3-.7.955.955 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.963.963 0 0 1-1.4 0 .959.959 0 0 1-.3-.7zm1.7-29.7a.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.955.955 0 0 1-.7.3.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7v-6a.951.951 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.4-29a.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.955.955 0 0 1-.7.3.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7v-6a.955.955 0 0 1 .3-.7zm281.4 116a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.96.96 0 0 1-.301-.7v-6a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.955.955 0 0 1 .7.3zm-1.7-22.3v-6a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.956.956 0 0 1-.301-.7zm0-35a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.963.963 0 0 1-.301-.7zm1.7-29.7a.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.954.954 0 0 1-.7.3.957.957 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.952.952 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-1.4-29a.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.954.954 0 0 1-.7.3.957.957 0 0 1-.699-.3.962.962 0 0 1-.301-.7v-6a.964.964 0 0 1 .301-.7zm-.3-28.3a.952.952 0 0 1 .301-.7.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.951.951 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.954.954 0 0 1-.7.3.957.957 0 0 1-.699-.3.962.962 0 0 1-.301-.7zm-48 22.85v-6a.956.956 0 0 1 .301-.7.953.953 0 0 1 .699-.3.957.957 0 0 1 .7.3.953.953 0 0 1 .3.7v6a.955.955 0 0 1-.3.7.95.95 0 0 1-.7.3.95.95 0 0 1-.699-.3.956.956 0 0 1-.301-.7zm0 29v-6a.956.956 0 0 1 .301-.7.953.953 0 0 1 .699-.3.957.957 0 0 1 .7.3.953.953 0 0 1 .3.7v6a.955.955 0 0 1-.3.7.95.95 0 0 1-.7.3.95.95 0 0 1-.699-.3.956.956 0 0 1-.301-.7zm-96-18.15a.95.95 0 0 1 .3-.7.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699zm48 0a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.955.955 0 0 1-.7.301.95.95 0 0 1-.699-.301.958.958 0 0 1-.301-.699zm-96 348a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm48 0a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm48 0a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .956.956 0 0 1-.301-.698zm48.3-17.55a.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.964.964 0 0 1 .301-.7zm48-16.85a.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.963.963 0 0 1-.301-.7v-6a.962.962 0 0 1 .301-.7zm1.4-29a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.96.96 0 0 1-.301-.7v-6a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.955.955 0 0 1 .7.3zm0-29a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.96.96 0 0 1-.301-.7v-6a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.955.955 0 0 1 .7.3zm-1.4-29a.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.963.963 0 0 1-.301-.7v-6a.962.962 0 0 1 .301-.7zm-.3-28.3a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.963.963 0 0 1-.301-.7zm1.7-29.7a.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.96.96 0 0 1-.301-.7v-6a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.955.955 0 0 1 .7.3zm-1.7-28.3a.95.95 0 0 1 .301-.7.953.953 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.959.959 0 0 1-.3.7.961.961 0 0 1-.7.3.96.96 0 0 1-.699-.3.963.963 0 0 1-.301-.7zm-48 167.85v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.955.955 0 0 1-.301-.7zm.3-35.7a.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.964.964 0 0 1 .301-.7zm0-29a.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.964.964 0 0 1 .301-.7zm-46.6 74.85a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .956.956 0 0 1-.301-.698zm-46.3 28.3a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm1.7-29.7a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm0-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm48 29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm0-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .956.956 0 0 1-.301-.698zm-48 0a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm1.7-29.7a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698zm49.7 28.3a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-1.7-28.3a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .956.956 0 0 1-.301-.698zm48 47.15v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.955.955 0 0 1-.301-.7zm0 29v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.955.955 0 0 1-.301-.7zm2-64v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.951.951 0 0 1 .3.7zm0-29v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.951.951 0 0 1 .3.7zm-2-23v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.961.961 0 0 1 .7.3.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.955.955 0 0 1-.301-.7zm1.7-35.7a.955.955 0 0 1 .3.7v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.955.955 0 0 1-.301-.7v-6a.956.956 0 0 1 .301-.7.96.96 0 0 1 .699-.3.955.955 0 0 1 .7.3zm.3-28.3v6a.954.954 0 0 1-.3.7.954.954 0 0 1-.7.3.953.953 0 0 1-.699-.3.958.958 0 0 1-.301-.7v-6a.956.956 0 0 1 .301-.7.953.953 0 0 1 .699-.3.957.957 0 0 1 .7.3.951.951 0 0 1 .3.7zm-49.7 74.15a.95.95 0 0 1 .699-.3.95.95 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .956.956 0 0 1-.301-.698v-6a.964.964 0 0 1 .301-.7zm1.4-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-49.4 29a.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.955.955 0 0 1 .3-.7zm1.4-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm0-29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.961.961 0 0 1-1.4 0 .95.95 0 0 1-.3-.698v-6a.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3.951.951 0 0 1 .7.3zm-1.4-29a.951.951 0 0 1 .7-.3.955.955 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.956.956 0 0 1-.7.301.952.952 0 0 1-.7-.301.953.953 0 0 1-.3-.699v-6a.955.955 0 0 1 .3-.7zm49.4 29a.948.948 0 0 1 .3.7v6a.95.95 0 0 1-.3.698.96.96 0 0 1-1.399 0 .952.952 0 0 1-.301-.698v-6a.95.95 0 0 1 .301-.7.95.95 0 0 1 .699-.3.951.951 0 0 1 .7.3zm-1.4-29a.95.95 0 0 1 .699-.3.954.954 0 0 1 .7.3.95.95 0 0 1 .3.7v6a.953.953 0 0 1-.3.699.955.955 0 0 1-.7.301.95.95 0 0 1-.699-.301.958.958 0 0 1-.301-.699v-6a.964.964 0 0 1 .301-.7z",
    id: "path57"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g71"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient735",
    gradientUnits: "userSpaceOnUse",
    x1: -83.068,
    y1: 504.503,
    x2: 205.603,
    y2: 506.633,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M190.45 394.35c2.566 16.934 21 30.301 55.3 40.101 30.9 8.8 68.167 13.216 111.8 13.25 43.367 0 80.45-4.351 111.25-13.05 33.967-9.5 51.935-22.384 53.9-38.65l-21 420.95c-10.4 16.866-31.117 29.982-62.15 39.35-28.2 8.567-60.5 12.9-96.9 13-35.7.102-67.517-3.833-95.45-11.8-29.9-8.566-49.184-20.217-57.85-34.95z",
    id: "path69",
    style: {
      fill: "url(#SVGID_6_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient745",
    gradientUnits: "userSpaceOnUse",
    x1: 518.991,
    y1: 505.375,
    x2: 303.192,
    y2: 506.212,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop743"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M190.1 393.8c2.566 16.935 21.017 30.3 55.35 40.101 30.9 8.8 68.15 13.199 111.75 13.199 43.399 0 80.5-4.316 111.3-12.949 33.933-9.566 51.884-22.467 53.85-38.7l1.4 421c-10.4 16.898-30.45 30.017-60.15 39.35-27 8.567-57.833 12.9-92.5 13-34 .102-64.333-3.85-91-11.85-28.567-8.567-47.184-20.217-55.85-34.95z",
    id: "path80",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g96"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient756",
    gradientUnits: "userSpaceOnUse",
    x1: -362.003,
    y1: 689.823,
    x2: -162.645,
    y2: 689.823,
    gradientTransform: "scale(1 -1) rotate(89.496 632.55 421.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop754"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M245.3 438.25c-33.933-12.4-51.883-29.15-53.85-50.25.267-22.733 17.966-40.35 53.1-52.85 31.267-11.134 69.733-16.4 115.4-15.801 21.2.301 41.6 1.967 61.2 5 20.1 3.134 37.75 7.483 52.949 13.051 16.101 5.866 28.384 12.75 36.851 20.649 9.133 8.5 13.383 17.784 12.75 27.851-2.566 21.967-21.017 39.316-55.351 52.05-30.899 11.433-68.149 17.167-111.75 17.2-43.399 0-80.499-5.633-111.299-16.9z",
    id: "path92",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M245.3 438.25c30.8 11.267 67.9 16.9 111.3 16.9 43.6-.033 80.85-5.768 111.75-17.2 34.333-12.733 52.784-30.083 55.351-52.05.633-10.066-3.617-19.351-12.75-27.851-8.467-7.899-20.75-14.783-36.851-20.649-15.199-5.566-32.85-9.917-52.949-13.051-19.601-3.033-40-4.699-61.2-5-45.667-.6-84.134 4.667-115.4 15.801-35.133 12.5-52.833 30.116-53.1 52.85 1.966 21.1 19.916 37.85 53.849 50.25z",
    id: "path94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g107"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient767",
    gradientUnits: "userSpaceOnUse",
    x1: 239.873,
    y1: 933.838,
    x2: 241.634,
    y2: 734.488,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop765"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M191.5 388c-.133.2-.183.066-.15-.4.066-.6.1-1 .1-1.199 1.966-21.101 19.917-37.851 53.85-50.25 30.8-11.268 67.9-16.9 111.3-16.9 43.6.033 80.85 5.767 111.75 17.2 34.066 12.633 52.5 29.815 55.301 51.55-12.867-18.667-35.801-32.883-68.801-42.65-29.967-8.866-63.883-12.949-101.75-12.25-37.067.667-70.25 5.733-99.55 15.2-31.2 10.066-51.883 23.299-62.05 39.699z",
    id: "path105",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g119"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient778",
    gradientUnits: "userSpaceOnUse",
    x1: -47.169,
    y1: 575.864,
    x2: 152.056,
    y2: 577.29,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop776"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M190.45 252.2c2.566 21.966 21 39.316 55.3 52.05 30.9 11.434 68.167 17.167 111.8 17.2 43.367 0 80.45-5.634 111.25-16.9 33.967-12.4 51.935-29.15 53.9-50.25l-21 547.05c-10.4 21.9-31.117 38.95-62.15 51.15-28.2 11.1-60.5 16.717-96.9 16.85-35.7.135-67.517-4.981-95.45-15.35-29.9-11.133-49.184-26.267-57.85-45.4z",
    id: "path117",
    style: {
      fill: "url(#SVGID_10_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g131"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient789",
    gradientUnits: "userSpaceOnUse",
    x1: 483.148,
    y1: 576.804,
    x2: 350.273,
    y2: 577.303,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop787"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M190.1 251.45c2.566 21.966 21.017 39.316 55.35 52.05 30.9 11.467 68.15 17.217 111.75 17.25 43.399 0 80.5-5.633 111.3-16.9 33.933-12.4 51.884-29.15 53.85-50.25l1.4 547.05c-10.4 21.933-30.45 38.981-60.15 51.148-27 11.102-57.833 16.717-92.5 16.852-34 .133-64.333-4.983-91-15.352-28.567-11.133-47.184-26.267-55.85-45.398z",
    id: "path129",
    style: {
      fill: "url(#SVGID_11_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g145"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient800",
    gradientUnits: "userSpaceOnUse",
    x1: -34.466,
    y1: 877.722,
    x2: 164.834,
    y2: 883.087,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop798"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M470.65 200.75c35.133 12.5 52.833 30.117 53.1 52.85-1.967 21.1-19.917 37.85-53.85 50.25-30.801 11.267-67.9 16.9-111.3 16.9-43.6-.033-80.85-5.767-111.75-17.2-34.333-12.733-52.783-30.083-55.35-52.05-.633-10.067 3.617-19.35 12.75-27.85 8.467-7.9 20.75-14.783 36.85-20.65 15.2-5.567 32.85-9.917 52.95-13.05 19.6-3.034 40-4.7 61.2-5 45.667-.6 84.133 4.667 115.4 15.8z",
    id: "path141",
    style: {
      fill: "url(#SVGID_12_)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M470.65 200.75c35.133 12.5 52.833 30.117 53.1 52.85-1.967 21.1-19.917 37.85-53.85 50.25-30.801 11.267-67.9 16.9-111.3 16.9-43.6-.033-80.85-5.767-111.75-17.2-34.333-12.733-52.783-30.083-55.35-52.05-.633-10.067 3.617-19.35 12.75-27.85 8.467-7.9 20.75-14.783 36.85-20.65 15.2-5.567 32.85-9.917 52.95-13.05 19.6-3.034 40-4.7 61.2-5 45.667-.6 84.133 4.667 115.4 15.8z",
    id: "path143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g158"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient811",
    gradientUnits: "userSpaceOnUse",
    x1: -517.95,
    y1: 973.345,
    x2: -318.578,
    y2: 973.345,
    gradientTransform: "scale(-1 1) rotate(-1.542 -27075.778 4917.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop809"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M359.95 184.95c21.2.3 41.6 1.966 61.2 5 20.1 3.133 37.75 7.483 52.949 13.05 16.101 5.867 28.384 12.75 36.851 20.65 9.133 8.5 13.383 17.783 12.75 27.85-2.566 21.967-21.017 39.316-55.351 52.05-30.899 11.435-68.149 17.167-111.75 17.2-43.4 0-80.5-5.633-111.3-16.9-33.933-12.4-51.883-29.15-53.85-50.25.267-22.733 17.966-40.35 53.1-52.85 31.267-11.133 69.734-16.4 115.401-15.8z",
    id: "path154",
    style: {
      fill: "url(#SVGID_13_)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M359.95 184.95c-45.667-.6-84.134 4.667-115.4 15.8-35.133 12.5-52.833 30.117-53.1 52.85 1.966 21.1 19.917 37.85 53.85 50.25 30.8 11.267 67.9 16.9 111.3 16.9 43.6-.033 80.85-5.767 111.75-17.2 34.333-12.733 52.784-30.083 55.351-52.05.633-10.067-3.617-19.35-12.75-27.85-8.467-7.9-20.75-14.783-36.851-20.65-15.199-5.567-32.85-9.917-52.949-13.05-19.601-3.033-40.001-4.7-61.201-5z",
    id: "path156"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g172"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient821",
    gradientUnits: "userSpaceOnUse",
    x1: -423.2,
    y1: 885.227,
    x2: 1215.2,
    y2: 885.227,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop819"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M359.95 184.95c21.2.3 41.6 1.966 61.2 5 20.1 3.133 37.75 7.483 52.949 13.05 16.101 5.867 28.384 12.75 36.851 20.65 9.133 8.5 13.383 17.783 12.75 27.85-2.566 21.967-21.017 39.317-55.351 52.05-30.899 11.435-68.149 17.167-111.75 17.2-43.4 0-80.5-5.633-111.3-16.9-24.133-8.833-40.183-19.85-48.15-33.05-2.667-4.433-4.417-9.1-5.25-14a35.12 35.12 0 0 1-.45-3.2c.267-22.733 17.966-40.35 53.1-52.85 31.268-11.133 69.734-16.4 115.401-15.8zm-.45 3.2c-43.933-.566-80.933 4.333-111 14.7-33.8 11.6-50.817 27.983-51.05 49.15 1.867 19.633 19.117 35.217 51.75 46.75 29.633 10.467 65.316 15.7 107.05 15.7 41.933-.034 77.75-5.367 107.45-16 33.033-11.833 50.783-27.967 53.25-48.4.6-9.367-3.483-18-12.25-25.9-8.133-7.367-19.95-13.783-35.45-19.25-14.6-5.167-31.567-9.2-50.9-12.1-18.867-2.833-38.483-4.383-58.85-4.65z",
    id: "path166",
    style: {
      fill: "url(#SVGID_14_)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M359.95 184.95c-45.667-.6-84.133 4.667-115.4 15.8-35.133 12.5-52.833 30.117-53.1 52.85.1 1.066.25 2.133.45 3.2.833 4.9 2.583 9.567 5.25 14 7.967 13.2 24.017 24.217 48.15 33.05 30.8 11.267 67.9 16.9 111.3 16.9 43.6-.033 80.85-5.767 111.75-17.2 34.333-12.733 52.784-30.083 55.351-52.05.633-10.067-3.617-19.35-12.75-27.85-8.467-7.9-20.75-14.783-36.851-20.65-15.199-5.567-32.85-9.917-52.949-13.05-19.601-3.033-40.001-4.7-61.201-5z",
    id: "path168"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M359.5 188.15c-43.933-.566-80.933 4.333-111 14.7-33.8 11.6-50.817 27.983-51.05 49.15 1.867 19.633 19.117 35.217 51.75 46.75 29.633 10.467 65.316 15.7 107.05 15.7 41.933-.034 77.75-5.367 107.45-16 33.033-11.833 50.783-27.967 53.25-48.4.6-9.367-3.483-18-12.25-25.9-8.133-7.367-19.95-13.783-35.45-19.25-14.6-5.167-31.567-9.2-50.9-12.1-18.867-2.833-38.483-4.383-58.85-4.65z",
    id: "path170"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g274"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient832",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 397.428,
    x2: 483.156,
    y2: 397.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop830"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M580.95 740.5c0-2.566.148-4.967.45-7.2.365-2.866.967-5.467 1.8-7.8 1.167-3.233 2.648-5.384 4.45-6.45a6.578 6.578 0 0 1 1.898-.7c.134-.032.268-.05.4-.05s.267.018.398.05v.75h-.198c-2.635.268-4.718 2.584-6.25 6.95-.768 2.167-1.334 4.584-1.7 7.25-.3 2.2-.45 4.584-.45 7.15 0 4.898.566 9.184 1.7 12.85.133.533.3 1.066.5 1.602 1.565 4.433 3.732 6.815 6.5 7.148 1.133.066 2.184-.383 3.148-1.35.102-.134.2-.25.302-.352 1-1.065 1.865-2.648 2.6-4.75.7-1.933 1.233-4.198 1.6-6.8.4-2.533.617-5.184.65-7.95.033-2.698-.083-5.216-.35-7.55-.334-2.732-.885-5.184-1.65-7.35-.2-.634-.417-1.217-.65-1.75h.5c.167.366.317.767.45 1.2.834 2.333 1.417 4.966 1.75 7.898.268 2.367.384 4.917.352 7.65a59.178 59.178 0 0 1-.65 8.2c-.434 2.698-1.017 5.083-1.75 7.148-.767 2.134-1.7 3.768-2.8 4.9-.102.133-.217.25-.352.35-1.032 1-2.166 1.467-3.398 1.4-2.935-.334-5.25-2.816-6.95-7.45-.267-.7-.5-1.434-.7-2.2-1.067-3.66-1.6-7.928-1.6-12.794z",
    id: "path180",
    style: {
      fill: "url(#SVGID_15_)"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g184"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M511.5 757.8a.955.955 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.953.953 0 0 1-.3-.7.953.953 0 0 1 .3-.7zm0-11.6a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.951.951 0 0 1 .3-.7zm25.7 11.3a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3zm0-11.6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm19 11.6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.955.955 0 0 1 .7-.3zm.7-11.3a.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm18.3 11.3a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.955.955 0 0 1 .7-.3zm.7-9.9a.96.96 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.954.954 0 0 1-.3.698zm18.3 9.9a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.955.955 0 0 1 .7-.3zm0-11.6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3zm-6.7-11.7a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm0-12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm-19 12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm0-12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm-19 12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm0-12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.955.955 0 0 1 .3-.7zm-19 13.4a.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.96.96 0 0 1-.7.302h-6a.967.967 0 0 1-.7-.302zm-19-1.4a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.951.951 0 0 1 .3-.7zm0-12a.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.951.951 0 0 1 .3-.7zm19 1.4a.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.96.96 0 0 1-.7.302h-6a.967.967 0 0 1-.7-.302zm82.7 33.9a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.955.955 0 0 1 .7-.3zm0-11.6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3zm0-24a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3zm0 12a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.951.951 0 0 1 .7-.3z",
    id: "path182"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g197"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient843",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.398,
    y1: -290.523,
    x2: -1760.096,
    y2: -285.157,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 966.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop841"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M521.928 724.954c.748 2.042 1.332 4.413 1.754 7.113.407 2.634.631 5.374.672 8.223.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.857.773-10.862 2.311-15.015 1.711-4.612 4.042-7.092 6.994-7.437 1.353-.085 2.6.485 3.741 1.713 1.061 1.138 1.986 2.788 2.774 4.951z",
    id: "path193",
    style: {
      fill: "url(#SVGID_16_)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M521.928 724.954c.748 2.042 1.332 4.413 1.754 7.113.407 2.634.631 5.374.672 8.223.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.857.773-10.862 2.311-15.015 1.711-4.612 4.042-7.092 6.994-7.437 1.353-.085 2.6.485 3.741 1.713 1.061 1.138 1.986 2.788 2.774 4.951z",
    id: "path195"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g210"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient854",
    gradientUnits: "userSpaceOnUse",
    x1: -544.419,
    y1: 519.259,
    x2: -505.13,
    y2: 519.259,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop852"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M522.25 725.4c1.467 4.198 2.167 9.365 2.1 15.5a59.672 59.672 0 0 1-.648 8.25c-.435 2.698-1.018 5.065-1.75 7.1-.8 2.167-1.733 3.816-2.8 4.95-1.135 1.232-2.385 1.8-3.75 1.7-2.935-.334-5.268-2.802-7-7.4-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.783 2.301-14.95 1.667-4.533 3.917-6.934 6.75-7.2 3.032.033 5.398 2.4 7.098 7.1z",
    id: "path206",
    style: {
      fill: "url(#SVGID_17_)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M522.25 725.4c-1.7-4.7-4.066-7.067-7.1-7.102-2.834.268-5.083 2.667-6.75 7.2-1.533 4.167-2.301 9.15-2.301 14.95 0 5.866.768 10.883 2.301 15.05 1.732 4.6 4.066 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.069-6.131-.631-11.298-2.098-15.498z",
    id: "path208"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient865",
    gradientUnits: "userSpaceOnUse",
    x1: 385.317,
    y1: 397.066,
    x2: 399.343,
    y2: 397.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop863"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M519.1 718c.102.7.15 1.4.15 2.1 0 1.034-.1 2.067-.3 3.102-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.117-1.352 5.55a34.748 34.748 0 0 0-.648 7.3c0 2.5.283 5.019.85 7.552.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.467.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.449-7.35-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.783 2.301-14.95 1.434-3.967 3.333-6.3 5.699-7z",
    id: "path219",
    style: {
      fill: "url(#SVGID_18_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g235"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient872",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.52,
    y1: -707.786,
    x2: -1685.52,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 966.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop870"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M517.031 762.878a3.915 3.915 0 0 1-.39-.007c-2.95-.345-5.281-2.823-6.992-7.437-1.536-4.149-2.307-9.153-2.312-15.012 0-5.83.756-10.813 2.271-14.952 1.403-3.843 3.225-6.16 5.461-6.952.226-.159.43-.299.61-.416a.626.626 0 0 1 .231-.138c-1.997 2.89-3.382 5.393-4.154 7.506-1.514 4.139-2.27 9.122-2.27 14.952.004 5.857.773 10.861 2.311 15.012 1.107 2.982 2.851 5.462 5.234 7.444z",
    id: "path226",
    style: {
      fill: "url(#SVGID_19_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient879",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.71,
    y1: -698.061,
    x2: -1684.71,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 966.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop877"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M510.127 726.251c1.486-4.231 3.388-6.871 5.702-7.919-2.302 3.407-3.942 7.328-4.923 11.761-.887 4.026-1.183 8.22-.887 12.581.277 4.07 1.031 7.877 2.264 11.419 1.209 3.476 2.77 6.354 4.682 8.638-3.166-1.594-5.54-4.604-7.12-9.033-1.411-3.954-2.066-8.568-1.968-13.845.089-5.07.839-9.603 2.25-13.602z",
    id: "path233",
    style: {
      fill: "url(#SVGID_20_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g248"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient890",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 436.207,
    x2: 432.678,
    y2: 409.432,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop888"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M509.3 725.8c1.5-4.033 3.533-6.616 6.102-7.75l74.75.102c-2.968.365-5.302 2.85-7 7.448-1.533 4.167-2.317 9.167-2.352 15 0 5.834.768 10.817 2.3 14.95 1.667 4.566 3.917 6.983 6.75 7.25l-73.5-2.8c-2.967-1.4-5.266-4.184-6.898-8.35-1.467-3.802-2.217-8.15-2.25-13.052-.035-4.798.665-9.065 2.098-12.798z",
    id: "path246",
    style: {
      fill: "url(#SVGID_21_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g259"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient900",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 364.972,
    x2: 432.675,
    y2: 382.821,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop898"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M509.6 754.9c-1.5-3.667-2.267-7.817-2.3-12.45 0-4.566.685-8.65 2.05-12.25 1.5-3.834 3.534-6.334 6.101-7.5l74.8-4.55c-2.967.333-5.3 2.8-7 7.398-1.533 4.167-2.3 9.167-2.3 15 0 5.834.75 10.834 2.25 15 1.667 4.533 3.917 6.935 6.75 7.2l-73.5.2c-2.934-1.398-5.218-4.082-6.851-8.048z",
    id: "path257",
    style: {
      fill: "url(#SVGID_22_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g270"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient910",
    gradientUnits: "userSpaceOnUse",
    x1: 460.318,
    y1: 397.066,
    x2: 474.344,
    y2: 397.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop908"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M594.1 718c.102.7.15 1.4.15 2.1 0 1.034-.1 2.067-.3 3.102-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.116-1.352 5.55a34.748 34.748 0 0 0-.648 7.3c0 2.5.283 5.018.85 7.552.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.466.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.448-7.35-1.533-4.167-2.302-9.184-2.302-15.05 0-5.8.769-10.783 2.302-14.95 1.433-3.967 3.333-6.3 5.698-7z",
    id: "path268",
    style: {
      fill: "url(#SVGID_23_)"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeWidth: 1.25,
    d: "M590.15 718.3c-2.834.268-5.084 2.667-6.75 7.2-1.533 4.167-2.302 9.15-2.302 14.95 0 5.866.769 10.883 2.302 15.05 1.732 4.6 4.065 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.067-6.135-.633-11.302-2.1-15.5-1.698-4.7-4.064-7.067-7.098-7.1z",
    id: "path272"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g375"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient920",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 507.428,
    x2: 483.156,
    y2: 507.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop918"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M580.95 630.5c0-2.566.148-4.967.45-7.2.365-2.866.966-5.467 1.8-7.8 1.166-3.233 2.648-5.384 4.45-6.45a6.578 6.578 0 0 1 1.898-.7c.134-.032.268-.05.4-.05s.267.018.398.05v.75h-.198c-2.635.268-4.718 2.584-6.25 6.95-.768 2.167-1.334 4.584-1.7 7.25-.3 2.2-.45 4.584-.45 7.15 0 4.898.566 9.184 1.7 12.85.133.533.3 1.066.5 1.602 1.565 4.433 3.732 6.815 6.5 7.148 1.133.066 2.184-.383 3.148-1.35.102-.134.2-.25.302-.352 1-1.065 1.865-2.648 2.6-4.75.7-1.933 1.233-4.198 1.6-6.8.4-2.533.617-5.184.65-7.95.033-2.698-.083-5.216-.35-7.55-.334-2.732-.885-5.184-1.65-7.35-.2-.634-.417-1.217-.65-1.75h.5c.167.366.317.767.45 1.2.834 2.333 1.417 4.966 1.75 7.898.268 2.367.384 4.917.352 7.65a59.332 59.332 0 0 1-.65 8.2c-.434 2.698-1.017 5.083-1.75 7.148-.767 2.134-1.7 3.768-2.8 4.9-.102.133-.217.25-.352.35-1.032 1-2.166 1.467-3.398 1.4-2.935-.334-5.25-2.816-6.95-7.45-.267-.7-.5-1.434-.7-2.2-1.067-3.66-1.6-7.928-1.6-12.794z",
    id: "path281",
    style: {
      fill: "url(#SVGID_24_)"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g285"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M575.2 647.5a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3zm.7-11.3a.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm31.3 13.3a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3zm-13-2a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3zm.7-11.3a.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm12.3 1.7a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302zm-12.3-13.7a.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm-.7-12.3a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm-19 12a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm0-12a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm38 0a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm0 12a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm-82 25.6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3zm6.7-11.9a.96.96 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.954.954 0 0 1-.3.698zm12.3 11.9a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3zm7-12.6a.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.955.955 0 0 1 .3.7zm-45 12.6a.96.96 0 0 1-.7-.3.953.953 0 0 1-.3-.7.953.953 0 0 1 .3-.7.955.955 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3zm6-13.6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3zm-6-10a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302zm6-14a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3zm32 12h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm7-11a.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.955.955 0 0 1 .3.7zm-26 13a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302zm6-14a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3z",
    id: "path283"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient931",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.394,
    y1: -290.527,
    x2: -1760.094,
    y2: -285.162,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 856.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop929"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M521.928 614.954c.748 2.042 1.332 4.413 1.754 7.113.407 2.634.631 5.374.672 8.223.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.857.773-10.862 2.311-15.015 1.711-4.612 4.042-7.092 6.994-7.437 1.353-.085 2.6.485 3.741 1.713 1.061 1.138 1.986 2.788 2.774 4.951z",
    id: "path294",
    style: {
      fill: "url(#SVGID_25_)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M521.928 614.954c.748 2.042 1.332 4.413 1.754 7.113.407 2.634.631 5.374.672 8.223.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.857.773-10.862 2.311-15.015 1.711-4.612 4.042-7.092 6.994-7.437 1.353-.085 2.6.485 3.741 1.713 1.061 1.138 1.986 2.788 2.774 4.951z",
    id: "path296"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g311"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient942",
    gradientUnits: "userSpaceOnUse",
    x1: -434.46,
    y1: 522.273,
    x2: -395.171,
    y2: 522.273,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop940"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M522.25 615.4c1.467 4.198 2.167 9.365 2.1 15.5a59.672 59.672 0 0 1-.648 8.25c-.435 2.698-1.018 5.065-1.75 7.1-.8 2.167-1.733 3.816-2.8 4.95-1.135 1.232-2.385 1.8-3.75 1.7-2.935-.334-5.268-2.802-7-7.4-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.783 2.301-14.95 1.667-4.533 3.917-6.934 6.75-7.2 3.032.033 5.398 2.4 7.098 7.1z",
    id: "path307",
    style: {
      fill: "url(#SVGID_26_)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M522.25 615.4c-1.7-4.7-4.066-7.067-7.1-7.102-2.834.268-5.083 2.667-6.75 7.2-1.533 4.167-2.301 9.15-2.301 14.95 0 5.866.768 10.883 2.301 15.05 1.732 4.6 4.066 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.069-6.131-.631-11.298-2.098-15.498z",
    id: "path309"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient953",
    gradientUnits: "userSpaceOnUse",
    x1: 385.317,
    y1: 507.066,
    x2: 399.343,
    y2: 507.23,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop951"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M519.1 608c.102.7.15 1.4.15 2.1 0 1.034-.1 2.067-.3 3.102-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.117-1.352 5.55a34.748 34.748 0 0 0-.648 7.3c0 2.5.283 5.019.85 7.552.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.467.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.449-7.35-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.783 2.301-14.95 1.434-3.967 3.333-6.3 5.699-7z",
    id: "path320",
    style: {
      fill: "url(#SVGID_27_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g336"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient960",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.52,
    y1: -707.786,
    x2: -1685.52,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 856.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop958"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M517.031 652.878a3.915 3.915 0 0 1-.39-.007c-2.95-.345-5.281-2.823-6.992-7.437-1.536-4.149-2.307-9.153-2.312-15.012 0-5.83.756-10.813 2.271-14.952 1.403-3.843 3.225-6.16 5.461-6.952.226-.159.43-.299.61-.416a.626.626 0 0 1 .231-.138c-1.997 2.89-3.382 5.393-4.154 7.506-1.514 4.139-2.27 9.122-2.27 14.952.004 5.857.773 10.861 2.311 15.012 1.107 2.982 2.851 5.462 5.234 7.444z",
    id: "path327",
    style: {
      fill: "url(#SVGID_28_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient967",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.708,
    y1: -698.061,
    x2: -1684.708,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 856.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop965"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M510.127 616.251c1.486-4.231 3.388-6.871 5.702-7.919-2.302 3.407-3.942 7.328-4.923 11.761-.887 4.026-1.183 8.22-.887 12.581.277 4.07 1.031 7.877 2.264 11.419 1.209 3.476 2.77 6.354 4.682 8.638-3.166-1.594-5.54-4.604-7.12-9.033-1.411-3.954-2.066-8.568-1.968-13.845.089-5.07.839-9.603 2.25-13.602z",
    id: "path334",
    style: {
      fill: "url(#SVGID_29_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g349"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient978",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 546.206,
    x2: 432.677,
    y2: 519.431,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop976"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M507.2 628.6c-.034-4.8.667-9.065 2.1-12.8 1.5-4.033 3.533-6.616 6.102-7.75l74.75.102c-2.968.365-5.302 2.85-7 7.448-1.534 4.167-2.317 9.167-2.352 15 0 5.834.768 10.817 2.3 14.95 1.667 4.566 3.917 6.983 6.75 7.25l-73.5-2.8c-2.966-1.4-5.266-4.184-6.898-8.35-1.469-3.8-2.219-8.15-2.252-13.05z",
    id: "path347",
    style: {
      fill: "url(#SVGID_30_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g360"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient988",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 474.972,
    x2: 432.675,
    y2: 492.822,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop986"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M509.35 620.2c1.5-3.834 3.534-6.334 6.101-7.5l74.8-4.55c-2.967.333-5.3 2.8-7 7.398-1.533 4.167-2.3 9.167-2.3 15 0 5.834.75 10.834 2.25 15 1.666 4.533 3.916 6.935 6.75 7.2l-73.5.2c-2.935-1.4-5.217-4.084-6.851-8.05-1.5-3.667-2.267-7.817-2.3-12.45 0-4.564.683-8.648 2.05-12.248z",
    id: "path358",
    style: {
      fill: "url(#SVGID_31_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g371"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient998",
    gradientUnits: "userSpaceOnUse",
    x1: 460.318,
    y1: 507.066,
    x2: 474.344,
    y2: 507.229,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop996"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M594.1 608c.102.7.15 1.4.15 2.1 0 1.034-.1 2.067-.3 3.102-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.116-1.352 5.55a34.748 34.748 0 0 0-.648 7.3c0 2.5.283 5.018.85 7.552.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.466.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.448-7.35-1.533-4.167-2.302-9.184-2.302-15.05 0-5.8.769-10.783 2.302-14.95 1.433-3.967 3.333-6.3 5.698-7z",
    id: "path369",
    style: {
      fill: "url(#SVGID_32_)"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeWidth: 1.25,
    d: "M590.15 608.3c-2.834.268-5.084 2.667-6.75 7.2-1.533 4.167-2.302 9.15-2.302 14.95 0 5.866.769 10.883 2.302 15.05 1.732 4.6 4.065 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.067-6.135-.633-11.302-2.1-15.5-1.698-4.7-4.064-7.067-7.098-7.1z",
    id: "path373"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g476"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1008",
    gradientUnits: "userSpaceOnUse",
    x1: 464.95,
    y1: 627.428,
    x2: 483.156,
    y2: 627.428,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop1004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop1006"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M587.65 489.05a6.578 6.578 0 0 1 1.898-.7c.134-.033.268-.05.4-.05s.267.018.398.05v.75h-.198c-2.635.268-4.718 2.583-6.25 6.95-.768 2.167-1.334 4.583-1.7 7.25-.3 2.2-.45 4.583-.45 7.15 0 4.898.566 9.184 1.7 12.85.133.533.3 1.066.5 1.602 1.565 4.433 3.732 6.815 6.5 7.148 1.133.066 2.184-.383 3.148-1.35.102-.134.2-.25.302-.352 1-1.065 1.865-2.648 2.6-4.75.7-1.933 1.233-4.198 1.6-6.8.4-2.533.617-5.184.65-7.95.033-2.699-.083-5.217-.35-7.55-.334-2.732-.885-5.183-1.65-7.35-.2-.634-.417-1.217-.65-1.75h.5c.167.366.317.767.45 1.2.834 2.333 1.417 4.967 1.75 7.899.268 2.367.384 4.917.352 7.65a59.332 59.332 0 0 1-.65 8.2c-.434 2.698-1.017 5.083-1.75 7.148-.767 2.134-1.7 3.768-2.8 4.9-.102.133-.217.25-.352.35-1.032 1-2.166 1.467-3.398 1.4-2.935-.334-5.25-2.816-6.95-7.45-.267-.7-.5-1.434-.7-2.2-1.065-3.666-1.6-7.934-1.6-12.8 0-2.566.148-4.967.45-7.2.365-2.866.966-5.466 1.8-7.8 1.166-3.228 2.65-5.378 4.45-6.445z",
    id: "path382",
    style: {
      fill: "url(#SVGID_33_)"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g386"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M537.9 529.2a.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4zm19.3-.7a.965.965 0 0 1-.3.7.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.957.957 0 0 1 .3.7zm-39-1a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.96.96 0 0 1-.7-.3.953.953 0 0 1-.3-.7.953.953 0 0 1 .3-.7.955.955 0 0 1 .7-.3zm-6-9.6a.957.957 0 0 1-.7-.302.947.947 0 0 1-.3-.698.948.948 0 0 1 .3-.7.951.951 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302zm6.7-12.3a.96.96 0 0 1-.7.301h-6a.952.952 0 0 1-.7-.301.95.95 0 0 1-.3-.699.95.95 0 0 1 .3-.7.951.951 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.955.955 0 0 1-.3.699zm-7.4-13.4a.951.951 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.952.952 0 0 1-.7-.301.95.95 0 0 1-.3-.699.951.951 0 0 1 .3-.7zm38.7 23.7h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm7-11a.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.955.955 0 0 1 .3.7zm-26 13a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302zm6.7-12.3a.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.955.955 0 0 1-.3.699zm-6.7-11.7a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301zm19-2h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm25.7 35.9a.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.96.96 0 0 1 .7.3zm19 0a.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3h-6a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.96.96 0 0 1 .7.3zm12.3 1.7a.957.957 0 0 1-.7-.3.957.957 0 0 1-.3-.7.957.957 0 0 1 .3-.7.954.954 0 0 1 .7-.3h6a.962.962 0 0 1 .7.3.965.965 0 0 1 0 1.4.959.959 0 0 1-.7.3zm-12.3-13.3a.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm-.7-12.3a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm-19 12a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm.7-11.7a.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm-.7-12.3a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm19.7.3a.96.96 0 0 1 .3.7.96.96 0 0 1-.3.699.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.951.951 0 0 1 .7.3zm18.3 23.7a.955.955 0 0 1 .7.3.96.96 0 0 1 .3.7.958.958 0 0 1-.3.698.964.964 0 0 1-.7.302h-6a.956.956 0 0 1-.7-.302.95.95 0 0 1-.3-.698.952.952 0 0 1 .3-.7.95.95 0 0 1 .7-.3zm.7-10.3a.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.955.955 0 0 1-.3.699zm0-12a.96.96 0 0 1-.7.301h-6a.95.95 0 0 1-.7-.301.953.953 0 0 1-.3-.699.954.954 0 0 1 .3-.7.95.95 0 0 1 .7-.3h6a.959.959 0 0 1 .7.3.96.96 0 0 1 .3.7.955.955 0 0 1-.3.699z",
    id: "path384"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g399"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1019",
    gradientUnits: "userSpaceOnUse",
    x1: -1959.392,
    y1: -290.525,
    x2: -1760.095,
    y2: -285.159,
    gradientTransform: "matrix(0 .1344 .1344 0 553.272 736.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop1013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop1015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop1017"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M521.928 494.954c.748 2.042 1.332 4.414 1.754 7.114.407 2.633.631 5.374.672 8.222.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.858.773-10.862 2.311-15.015 1.711-4.612 4.042-7.091 6.994-7.437 1.353-.085 2.6.486 3.741 1.713 1.061 1.137 1.986 2.788 2.774 4.951z",
    id: "path395",
    style: {
      fill: "url(#SVGID_34_)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M521.928 494.954c.748 2.042 1.332 4.414 1.754 7.114.407 2.633.631 5.374.672 8.222.08 6.136-.628 11.304-2.122 15.505-1.681 4.72-4.048 7.098-7.102 7.134-2.835-.265-5.085-2.676-6.751-7.234-1.514-4.139-2.271-9.122-2.271-14.953.004-5.858.773-10.862 2.311-15.015 1.711-4.612 4.042-7.091 6.994-7.437 1.353-.085 2.6.486 3.741 1.713 1.061 1.137 1.986 2.788 2.774 4.951z",
    id: "path397"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g412"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1030",
    gradientUnits: "userSpaceOnUse",
    x1: -314.506,
    y1: 525.56,
    x2: -275.216,
    y2: 525.56,
    gradientTransform: "scale(1 -1) rotate(88.43 643.343 423.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.3882
    },
    id: "stop1024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1922
    },
    id: "stop1026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2706
    },
    id: "stop1028"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M522.25 495.4c1.467 4.199 2.167 9.366 2.1 15.5a59.647 59.647 0 0 1-.648 8.25c-.435 2.698-1.018 5.065-1.75 7.1-.8 2.167-1.733 3.816-2.8 4.95-1.135 1.232-2.385 1.8-3.75 1.7-2.935-.334-5.268-2.802-7-7.4-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.784 2.301-14.95 1.667-4.533 3.917-6.934 6.75-7.2 3.032.033 5.398 2.4 7.098 7.1z",
    id: "path408",
    style: {
      fill: "url(#SVGID_35_)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M522.25 495.4c-1.7-4.7-4.066-7.066-7.1-7.101-2.834.268-5.083 2.667-6.75 7.2-1.533 4.167-2.301 9.15-2.301 14.95 0 5.866.768 10.883 2.301 15.05 1.732 4.6 4.066 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.069-6.132-.631-11.299-2.098-15.499z",
    id: "path410"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1041",
    gradientUnits: "userSpaceOnUse",
    x1: 385.318,
    y1: 627.067,
    x2: 399.343,
    y2: 627.231,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop1035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop1037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop1039"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M519.1 488c.102.7.15 1.4.15 2.1 0 1.033-.1 2.066-.3 3.101-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.117-1.352 5.55a34.742 34.742 0 0 0-.648 7.3c0 2.5.283 5.017.85 7.551.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.466.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.449-7.35-1.533-4.167-2.301-9.184-2.301-15.05 0-5.8.768-10.784 2.301-14.95 1.434-3.967 3.333-6.3 5.699-7z",
    id: "path421",
    style: {
      fill: "url(#SVGID_36_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g437"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1048",
    gradientUnits: "userSpaceOnUse",
    x1: -1685.517,
    y1: -707.786,
    x2: -1685.517,
    y2: -30.236,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 736.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop1044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop1046"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M517.031 532.878a3.915 3.915 0 0 1-.39-.007c-2.95-.345-5.281-2.823-6.992-7.437-1.536-4.149-2.307-9.153-2.312-15.012 0-5.831.756-10.813 2.271-14.952 1.403-3.843 3.225-6.161 5.461-6.952.226-.159.43-.299.61-.415a.616.616 0 0 1 .231-.139c-1.997 2.891-3.382 5.393-4.154 7.506-1.514 4.139-2.27 9.122-2.27 14.952.004 5.857.773 10.861 2.311 15.013 1.107 2.981 2.851 5.461 5.234 7.443z",
    id: "path428",
    style: {
      fill: "url(#SVGID_37_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1055",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.704,
    y1: -698.06,
    x2: -1684.704,
    y2: -34.861,
    gradientTransform: "matrix(0 .1343 .1343 0 553.515 736.788)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    id: "stop1051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    },
    id: "stop1053"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M510.127 496.251c1.486-4.231 3.388-6.872 5.702-7.919-2.302 3.408-3.942 7.328-4.923 11.761-.887 4.026-1.183 8.22-.887 12.581.277 4.07 1.031 7.877 2.264 11.419 1.209 3.476 2.77 6.354 4.682 8.639-3.166-1.595-5.54-4.605-7.12-9.034-1.411-3.954-2.066-8.568-1.968-13.844.089-5.07.839-9.604 2.25-13.603z",
    id: "path435",
    style: {
      fill: "url(#SVGID_38_)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g450"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1066",
    gradientUnits: "userSpaceOnUse",
    x1: 432.483,
    y1: 666.208,
    x2: 432.678,
    y2: 639.432,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop1060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop1062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop1064"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M583.15 495.6c-1.534 4.167-2.317 9.167-2.352 15 0 5.833.768 10.817 2.3 14.95 1.667 4.566 3.917 6.983 6.75 7.25l-73.5-2.8c-2.966-1.4-5.266-4.184-6.898-8.35-1.467-3.802-2.217-8.15-2.25-13.051-.034-4.8.667-9.066 2.1-12.8 1.5-4.033 3.533-6.616 6.102-7.75l74.75.101c-2.968.367-5.302 2.85-7.002 7.45z",
    id: "path448",
    style: {
      fill: "url(#SVGID_39_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g461"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1076",
    gradientUnits: "userSpaceOnUse",
    x1: 432.604,
    y1: 594.973,
    x2: 432.675,
    y2: 612.822,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop1070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop1072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop1074"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M583.25 495.55c-1.533 4.167-2.3 9.167-2.3 15 0 5.834.75 10.834 2.25 15 1.666 4.533 3.916 6.935 6.75 7.2l-73.5.2c-2.935-1.4-5.217-4.084-6.851-8.05-1.5-3.667-2.267-7.817-2.3-12.45 0-4.567.685-8.65 2.05-12.25 1.5-3.833 3.534-6.333 6.101-7.5l74.8-4.55c-2.967.333-5.3 2.8-7 7.4z",
    id: "path459",
    style: {
      fill: "url(#SVGID_40_)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g472"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1086",
    gradientUnits: "userSpaceOnUse",
    x1: 460.317,
    y1: 627.067,
    x2: 474.343,
    y2: 627.231,
    gradientTransform: "matrix(1 0 0 -1 116 1138.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0.3882
    },
    id: "stop1080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1922
    },
    id: "stop1082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    },
    id: "stop1084"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M594.1 488c.102.7.15 1.4.15 2.1 0 1.033-.1 2.066-.3 3.101-.167 1.033-.583 2.633-1.25 4.8-.634 2.267-1.083 4.117-1.352 5.55a34.742 34.742 0 0 0-.648 7.3c0 2.5.283 5.017.85 7.551.367 1.767.935 3.815 1.7 6.148.9 2.768 1.434 4.417 1.6 4.95.067.233.117.45.15.65.3 1.333.4 2.466.3 3.398l-5.45-.7c-2.698-.6-4.85-3.05-6.448-7.35-1.533-4.167-2.302-9.184-2.302-15.05 0-5.8.769-10.784 2.302-14.95 1.433-3.967 3.333-6.3 5.698-7z",
    id: "path470",
    style: {
      fill: "url(#SVGID_41_)"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeWidth: 1.25,
    d: "M590.15 488.3c-2.834.268-5.084 2.667-6.75 7.2-1.533 4.167-2.302 9.15-2.302 14.95 0 5.866.769 10.883 2.302 15.05 1.732 4.6 4.065 7.066 7 7.4 1.365.1 2.615-.468 3.75-1.7 1.065-1.134 2-2.783 2.8-4.95.732-2.033 1.315-4.4 1.75-7.1.398-2.635.616-5.385.648-8.25.067-6.134-.633-11.301-2.1-15.5-1.698-4.7-4.064-7.067-7.098-7.1z",
    id: "path474"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_3_",
    transform: "matrix(.37156 0 0 .37156 218.03 -56.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g481"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7493b0",
    d: "M752 745.3c0 11.167-3.934 20.685-11.8 28.55-7.867 7.834-17.384 11.75-28.55 11.75-11.167 0-20.685-3.916-28.552-11.75-7.833-7.865-11.75-17.383-11.75-28.55 0-11.167 3.917-20.683 11.75-28.55 7.867-7.867 17.385-11.8 28.552-11.8 11.166 0 20.683 3.933 28.55 11.8 7.866 7.867 11.8 17.383 11.8 28.55z",
    id: "path479"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g485"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M705.95 739.85c.033-1.065-.066-1.8-.3-2.198-.233-.367-.784-.567-1.65-.602l-2.75-.148v-1.4a47.47 47.47 0 0 0 4.85-.85c1.602-.4 3.233-.852 4.9-1.352v16.45c0 .767.05 1.384.15 1.85.1.435.315.768.648 1 .334.167.867.302 1.602.4l2.698.25v1.5h-15.3v-1.5l2.8-.3c1.034-.066 1.685-.334 1.95-.8.3-.468.435-1.268.4-2.4z",
    id: "path483"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g491"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7493b0",
    d: "M711.65 588.1c11.166 0 20.683 3.935 28.55 11.802 7.866 7.865 11.8 17.383 11.8 28.55 0 11.167-3.934 20.683-11.8 28.55-7.867 7.867-17.384 11.8-28.55 11.8-11.135 0-20.635-3.933-28.5-11.8-7.867-7.867-11.802-17.383-11.802-28.55 0-11.167 3.935-20.685 11.802-28.55 7.867-7.869 17.367-11.802 28.5-11.802z",
    id: "path489"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g495"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M702.3 618.35a8.8 8.8 0 0 1 2.75-1.948c1-.468 2.15-.7 3.45-.7 1.5 0 2.8.3 3.9.898 1.133.602 2 1.417 2.6 2.45.6 1 .917 2.15.95 3.45 0 1.4-.417 2.684-1.25 3.85-.834 1.135-2.167 2.334-4 3.602-.5.398-1.102.866-1.8 1.398-.667.534-1.435 1.135-2.302 1.802v.1h6.75c.802.033 1.435-.017 1.9-.15.467-.1.866-.333 1.2-.698.333-.334.684-.885 1.05-1.65l1.35.35-1.5 6.052H699.6V636c1-.667 2.135-1.434 3.4-2.3a35.596 35.596 0 0 0 3.55-2.852c1.167-1.032 2.117-2.133 2.852-3.3.732-1.2 1.115-2.45 1.148-3.75 0-.8-.148-1.533-.45-2.2a4.049 4.049 0 0 0-1.35-1.648c-.634-.4-1.45-.617-2.45-.65-.833.033-1.6.25-2.3.65a6.736 6.736 0 0 0-1.8 1.45c-.5.565-.967 1.133-1.4 1.698l-1.148-.948z",
    id: "path493"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g501"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7493b0",
    d: "M711.7 472.95c11.133 0 20.633 3.917 28.5 11.75 7.866 7.867 11.8 17.383 11.8 28.55 0 11.167-3.934 20.684-11.8 28.55-7.867 7.867-17.367 11.8-28.5 11.8-11.167 0-20.685-3.933-28.55-11.8-7.867-7.866-11.802-17.383-11.802-28.55 0-11.167 3.935-20.683 11.802-28.55 7.867-7.833 17.383-11.75 28.55-11.75z",
    id: "path499"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g505"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M712.75 502.7c1.2 1.065 1.8 2.517 1.8 4.35 0 .667-.133 1.25-.398 1.75-.233.5-.602.935-1.102 1.3-.366.333-.815.7-1.35 1.101-.533.399-1.15.815-1.852 1.25v.1c1.435.2 2.635.634 3.602 1.3 1 .667 1.75 1.468 2.25 2.4.5.967.75 1.983.75 3.05-.033 1.533-.367 2.884-1 4.05a10.495 10.495 0 0 1-2.5 3.052 15.115 15.115 0 0 1-3.25 2.1c-1.134.566-2.185.983-3.15 1.25-.965.267-1.717.4-2.25.4-.967-.034-1.85-.218-2.648-.552-.802-.3-1.417-.648-1.852-1.05-.3-.267-.5-.55-.6-.85-.134-.3-.134-.65 0-1.05.1-.268.25-.534.45-.802.198-.3.433-.532.698-.698.233-.2.468-.302.7-.302.233.034.45.15.65.352.366.333.815.684 1.35 1.05.533.4 1.117.733 1.75 1a5.919 5.919 0 0 0 2.05.45c.768 0 1.483-.233 2.15-.7.667-.434 1.2-1.116 1.6-2.05.4-.935.617-2.117.65-3.55-.033-1.4-.3-2.552-.8-3.45-.533-.867-1.185-1.5-1.95-1.9-.8-.398-1.583-.6-2.35-.6-.534 0-1.034.05-1.5.148-.5.102-.95.218-1.352.352l-.35-1.4c2.065-.767 3.684-1.667 4.85-2.7 1.167-1.032 1.75-2.282 1.75-3.75-.033-1.3-.383-2.282-1.05-2.949-.7-.667-1.583-1-2.65-1-1 .032-1.898.366-2.698 1a11.026 11.026 0 0 0-2 2.149l-1.052-.95 2.052-2.85c.6-.7 1.398-1.283 2.398-1.75.967-.5 2.033-.75 3.2-.75h.05c2.104.032 3.754.599 4.954 1.699z",
    id: "path503"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem14B);
export default __webpack_public_path__ + "static/media/item14b.8505ab3061206c931c2c1a1a935fe1a2.svg";
export { ForwardRef as ReactComponent };